import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
//import * as files from '../../fileUtils';

export default {
  name: 'EmployeeSchedules',
  components: {
    EmployeeScheduleComp: require('./employeeSchedule.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      periodTypes: [],
      usageTypes: [],
      rateTypes: [],
      schedules: [],
      employees: [],
      stations: [],
      editingSchedule: {},
      options: { pageSize: 5, total: 0, page: 1 },
      message: '',
      showSchedule: false,
      totalRow: 0
    }
  },
  created() {
    this.appId = this.dataObj;
    this.getStations();
    this.getLookups();
    this.getSchedules();
    this.getAvailableScheduleEmployees();
  },
  methods: {
    pageChange(pInfo) {
      //var parameters = { Value: this.appId, PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search };
      this.getSchedules();
    },
    getPeriodText(iKey) {
      return (this.periodTypes.filter(t => t.id == iKey).length > 0) ? this.periodTypes.filter(t => t.id == iKey)[0].name : '';
    },
    getUsageText(iKey) {
      return (this.usageTypes.filter(t => t.id == iKey).length > 0) ? this.usageTypes.filter(t => t.id == iKey)[0].name : '';
    },
    getRateText(iKey) {
      return (this.rateTypes.filter(t => t.id == iKey).length > 0) ? this.rateTypes.filter(t => t.id == iKey)[0].name : '';
    },
    getStations() {
      axios.post('/EmployeeApplication/GetStations')
        .then(response => {
          if (response.data.data.status == 0) {
            this.stations = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getAvailableScheduleEmployees() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/EmployeeApplication/GetAvailableScheduleEmployees')
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.items.forEach((item) => { item.fullname = item.name + " - " + item.orgpost; });
            this.employees = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getLookups() {
      axios.post('/EmployeeApplication/GetEmployeeScheduleLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.periodTypes = response.data.periodTypes;
            this.usageTypes = response.data.usageTypes;
            this.rateTypes = response.data.rateTypes;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getSchedules() {
      var parameters = { ApplicationId: this.appId, Options: this.options };
      axios.post('/EmployeeApplication/GetEmployeeSchedules', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.schedules = response.data.items;
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    add() {
      var now = moment();
      this.editingSchedule = {
        employeeId: 0, applicationId: this.appId, id: 0, periodTypeId: 1, periodDate: new Date(), periodBegin: now, periodEnd: now, readonly: false,
        periodBeginHH: 0, periodBeginMin: 0, periodEndHH: 0, periodEndMin: 0, usageTypeId: 204, rateType: 1,
        periodTypes: this.periodTypes, usageTypes: this.usageTypes, rateTypes: this.rateTypes, employees: this.employees, stations: this.stations, employee: ''
      };
      this.$root.$emit('employee_schedule_updated');
      this.showSchedule = true;
    },
    edit(schedule) {
      this.editingSchedule = schedule;

      this.editingSchedule.periodBeginHH = moment(this.editingSchedule.periodBegin).format('HH');
      this.editingSchedule.periodBeginMin = moment(this.editingSchedule.periodBegin).format('mm');
      this.editingSchedule.periodEndHH = moment(this.editingSchedule.periodEnd).format('HH');
      this.editingSchedule.periodEndMin = moment(this.editingSchedule.periodEnd).format('mm');

      this.editingSchedule.periodTypes = this.periodTypes;
      this.editingSchedule.usageTypes = this.usageTypes;
      this.editingSchedule.rateTypes = this.rateTypes;
      this.editingSchedule.stations = this.stations;
      this.editingSchedule.employees = this.employees;
      if (this.editingSchedule.employeeId > 0)
        this.editingSchedule.employee = this.editingSchedule.employees.filter(item => item.employeeId === this.editingSchedule.employeeId)[0],

          this.editingSchedule.readonly = false;
      this.$root.$emit('employee_schedule_updated');
      this.showSchedule = true;
    },
    saveSchedule() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      this.editingSchedule.employeeId = this.editingSchedule.employee.employeeId;
      var parameter = { Value: this.editingSchedule };
      axios.post('/EmployeeApplication/InsertOrUpdateEmployeeSchedule', { Value: this.editingSchedule })
        .then(response => {
          if (response.data.data.status == 0) {

            var time = moment(this.editingSchedule.periodBeginHH + ':' + this.editingSchedule.periodBeginMin, 'HH:mm');
            this.editingSchedule.periodBegin = moment(this.editingSchedule.periodBegin);

            this.editingSchedule.periodBegin.set({
              hour: time.get('hour'),
              minute: time.get('minute')
            });

            var time = moment(this.editingSchedule.periodEndHH + ':' + this.editingSchedule.periodEndMin, 'HH:mm');
            this.editingSchedule.periodEnd = moment(this.editingSchedule.periodEnd);

            this.editingSchedule.periodEnd.set({
              hour: time.get('hour'),
              minute: time.get('minute')
            });

            if (this.editingSchedule.id <= 0) {
              this.editingSchedule.id = response.data.id;
              this.schedules.push(this.editingSchedule);
              this.options.total = this.schedules.length;
            }
            this.$alertMsg('Schedule saved successfully.', 2);
          }
          else
            this.$alertMsg(response.data.data.text);

          loader.hide();
          this.showSchedule = false;
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    remove(id) {
      axios.post('/EmployeeApplication/DeleteEmployeeSchedule', { Value: id })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.ScheduleDeletedSuccess'), 2);
            this.getSchedules();
          }
        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    getTimeLabel(fullDate) {
      var res = new Date(fullDate);
      return (res.getHours() < 10 ? '0' + res.getHours() : res.getHours()) + ':' + (res.getMinutes() < 10 ? '0' + res.getMinutes() : res.getMinutes());
    },
    closeDialog() {
      this.editingMessage = '';
      this.getSchedules();
      this.showSchedule = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getSchedules();
    },
  }
  
}

